import React from 'react';
import { useTranslation } from 'react-i18next';
import { RotateCcw } from 'lucide-react';
import { cn } from '../../utils/cn';

const RefreshButton = ({ 
  onClick, 
  loading = false, 
  disabled = false, 
  size = 'sm',
  className = '',
  title
}) => {
  const { t } = useTranslation('common');
  const resolvedTitle = title ?? t('actions.refresh');
  const sizeClasses = {
    xs: 'w-6 h-6 p-1',
    sm: 'w-8 h-8 p-1.5',
    md: 'w-10 h-10 p-2'
  };

  return (
    <button
      onClick={onClick}
      disabled={loading || disabled}
      title={resolvedTitle}
      className={cn(
        'inline-flex items-center justify-center rounded-md',
        'text-gray-500 hover:text-gray-700 hover:bg-gray-100',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1',
        'transition-all duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        sizeClasses[size],
        className
      )}
    >
      <RotateCcw 
        className={cn(
          'w-full h-full',
          loading && 'animate-spin'
        )}
      />
    </button>
  );
};

export default RefreshButton;